import { createContext } from 'react';
export const ApprovalOperationPanelContext = /*#__PURE__*/createContext(undefined);